import script from "./ButtonRoundedGhost.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonRoundedGhost.vue?vue&type=script&setup=true&lang=js"

import "./ButtonRoundedGhost.vue?vue&type=style&index=0&id=77eef410&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77eef410"]])

export default __exports__